export default {
  // 知識庫
  knowledge: {
    all: '全部知識',
    mycreate: '我創建的',
    mydepartment: '我部門的',
    mycollection: '我收藏的',
    myinvite: '邀我回答',
    item: '條',
    knowledgeClassify: '知識分類',
    putQuestion: '提 問',
    addKnowledge: '新建知識',
    addKnowledge2: '新建知識庫',
    addputQuestion: '新建提問',
    knowledgeNote: '傳承智慧，啟迪未來。',
    putQuestionNote: '提出問題，尋找答案。',
    label: '標簽',
    publishedIn: '發布於',
    read: '閱讀',
    collection: '收藏',
    praise: '點贊',
    GeAnswer: '個回答',
    answer: '回答',
    loadMore: '加載更多…',
    video: '視頻',
    title_empty: '標題不能為空',
    content_empty: '內容不能為空',
    classify_empty: '分類不能為空',
    basicInfo: '基本信息',
    title: '標題',
    videoName: '視頻名稱',
    videoLink: '視頻地址',
    videoPlaceholder: '請將外部媒體地址粘貼至輸入框',
    supportTip: '支持騰訊視頻、優酷、愛奇藝、土豆。',
    addVideo: '添加視頻',
    quote: '引用',
    addContent: '添加內容',
    classify: '分類',
    attachment: '附件',
    supportExtension: '支持擴展名',
    addmemo: '新增備忘錄',
    versionManage: '版本管理',
    writeAnswer: '寫回答',
    showAll: '顯示全部',
    inviteAnswer: '邀人回答',
    look: '查看',
    studied: '已學習',
    study: '學習',
    answerTimeOrder: '按回答時間順序排序',
    updateTimeSort: '按更新時間順序排序',
    top: '置頂',
    cancelTop: '取消置頂',
    move: '移動',
    cancelLearn: '取消學習',
    confirmLearn: '確認學習',
    liked: '已點贊',
    collected: '已收藏',
    on: '於',
    answeredTheQuestion: '回答了此問題',
    putUp: '收起',
    expand: '展開',
    learnTip:
      '如果妳已經學習完該知識，請點擊“確定”按鈕，系統會將妳的學習狀態標記下來，以便管理員查詢員工學習記錄。',
    confirmtransferknowledge: '確認要將該知識',
    what: '嗎',

    classifyManage: '分類管理',
    tagManage: '標簽管理',
    dataquery: '數據查詢',
    filedName: '字段名稱',
    name: '名稱',
    dragsortTip: '您可以用鼠標上下拖動字段名稱，對選項順序進行排序。',
    labelname: '標簽名稱',
    nolabelyet: '暫無標簽~',
    categoryname: '分類名稱',
    administrator: '管理員',
    defaultclassification: '默認分類',
    open: '公開',
    private: '私有',
    openTip: '公開（企業所有成員均可見此分類）',
    privateTip: '私有（只有加入成員可見此分類）',
    delclassTip: '刪除後不可恢復，該分類的知識將被歸屬到默認分類中。',
    addcategories: '添加分類',
    newcategory: '新增分類',
    editcategories: '編輯分類',
    categoryname_empty: '分類名稱不能為空',
    categorymember_empty: '分類成員不能為空',
    categoryadmin_empty: '分類管理員不能為空',
    newlabel: '新增標簽',
    labelname_empty: '標簽名稱不能為空',
    edittab: '編輯標簽',
    type: '類型',
    test: ''
  }
}
